define(function (require) {
    var $ = require("jquery");

    $(document).ready(function () {
        var flag = $("#PdfGenerationProcessorHandler");

        if (flag.length > 0) {
            var sequenceNumber = getParameterByName("id");

            var ajaxFunction = null;
            ajaxFunction = function() {
                $.ajax({
                    url: "/controller/GeneratedFile/Status",
                    type: "GET",
                    data: { sequenceNumber: sequenceNumber },
                    context: this,
                    dataType: 'json',
                    success: function(data) {
                        if (data == null || data.Status === "Pending") {
                            setTimeout(ajaxFunction, 2000);
                            return;
                        }

                        if (data.Status === "Success") {
                            window.location = "/controller/GeneratedFile/Download?sequenceNumber=" + sequenceNumber;
                        } else {
                            showErrorMessage();
                        }
                    },
                    error: function(data) {
                        showErrorMessage();
                    }
                });
            };

            ajaxFunction();
        }
    });

    function showErrorMessage() {
        $("#pdfGenerationError span.form-error-text").show();
    }

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
});
